import React, { FC } from 'react';
import SectionMessage from '@atlaskit/section-message';

const LoadingInterimResults: FC = () => (
  <SectionMessage appearance="information" actions={[]}>
    Latest results are still loading.
  </SectionMessage>
);

export default LoadingInterimResults;
